<template>
  <div class="Componycontainer" @click="body">
    <my-header></my-header> 
    <!-- 新闻动态 -->
    <div class="content">
      <div class="banner">
        <img src="@/assets/img/dabeijing.png" alt="">
        <div>
          <p class="p1">新闻动态</p>
          <p class="p2">NEWS INFORMATION</p>
        </div>
      </div>
      <div class="Htitle" style="margin-top:3%">
        <div class="HtitleLeft">
          <div class="Left1">
            <p v-for="(item,index) in whole" :key="index" v-on:click="addClass(item)" v-bind:class="{ active:item.queryTime == current}">{{item.time}}</p>
          </div>
          <div class="Left2" style="display:flex">          
            <ul>
              <li @click="drop">
                <img src="../assets/img/shijianlan.png">
                <span> {{rightTitle}}</span>
                <img src="../assets/img/xiala1.png" >
                <div v-if="show" class="drop">
                  <li class="dropTitle">
                    <img src="../assets/img/shijianbai.png" >
                    <span>时间</span>
                    <img src="../assets/img/xiala.png">
                  </li>
                  <div class="dataContent">
                    <li class="dropContent" v-for="(item, index) in options" :key="index" v-on:click="addClass(item)" v-bind:class="{ active:item.queryTime == current}"><p>{{ item.time }}</p></li> 
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="tabTitle" >
          <ul>
            <li @click="cur=0" :class="{active:cur==0}" class="oneLi">卡片</li>
            <li style="margin:0 10px;"> | </li>
            <li @click="cur=1" :class="{active:cur==1}" class="twoLi">列表</li>
          </ul>
        </div>
      </div>
      <div class="main" >
        <div class="tab">
          <div class="tabContent">
            <!-- 卡片 -->
            <div v-show="cur==0" class="oneContent">
              <ul id=ilcount>
                <li v-for="(item, index) in newsList" :key="index" @click="goNewsdetail(item.id)">
                  <div class="TopImg" >
                    <img :src="item.image" alt="" :onerror="errorImg01">
                  </div>
                  <div class="detailContent">
                   <p class="ItemTitle" >{{item.title}}</p>
                    <div class="Content1">
                      <!-- <div class="ncontent1" v-html="item.content"></div> -->
                      <div class="ncontent1">{{delHtmlTag(item.content)}}</div>
                    </div>
                    <div class="oneData">
                      <div>
                        <span> {{item.source}}</span>
                      </div>
                       <span style="float:right">{{item.addTime}}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <!-- 列表 -->
            <div v-show="cur==1" class="twoContent">
              <ul>
                <li v-for="(item, index) in newsList" :key="index" @click="goNewsdetail(item.id)">
                  <p class="ItemTitle">{{ item.title }}</p>
                  <div class="Content2">
                    <div class="ncontent2"> {{delHtmlTag(item.content)}}</div>
                  </div> 
                  <div class="twoData">
                    <span> {{item.source}}</span>
                    <span style="float:right">{{ item.addTime }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div> 
        <!-- 分页 -->
        <div class="block">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-size="6"
            layout="prev, pager,next" 
            v-if="newsTotal!=0"
            :total="newsTotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <div><my-footer></my-footer></div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import axios from 'axios';
  import myHeader from "@/components/Headers.vue";
  import myFooter from "@/components/Footers.vue";
  import { Pagination, Carousel} from 'element-ui';
  Vue.use(Pagination,Carousel)
  export default {
    data() {
      return {
        i:0,
        errorImg01: 'this.src="' + require('../assets/img/empty.png') + '"',
        whole:[
          {
            id:0,
            queryTime:5,
            time:"全部"
          }
        ],
        selectedOption:{id:0,time:"时间"},
        options:[
          {
            id:1,
            queryTime:1,
            time:"近一个月"
          },{
            id:2,
            queryTime:2,
            time:"近三个月"
          },{
            id:3,
            queryTime:3,
            time:"近六个月"
          }
          ,{
            id:4,
            queryTime:4,
            time:"近一年"
          },{
            id:5,
            queryTime:5,
            time:"更久"
          }
        ],
        newDetail:{}, 
        titleList:[],
        newsList :[],
        pageSize:6,
        currentPage1: 1,//当前页码
        newsTotal:0,//总条数
        current:'',
        customerNum:0,
        rightTitle:'',
        active:0,
        cur:0,
        show:false,
      };
    },
    components:{
      myHeader,
      myFooter,
    },
    methods: {
      delHtmlTag(str){
        var one=str.replace(/<\/?.+?>/g,"");
        var two=one.replace(/&nbsp;/g,"");
        var three=two.replace(/&ldquo;/g,'"').replace(/&rdquo;/g,'"')
        return three
        // return str.replace(/<[^>]+>/g,"").replace(/[/&nbs/]/g,"").replace(/[/p;/]/g,"");
      },
      //监听鼠标滚动的长度
      scrollToTop(){ 
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if(scrollTop>$('.banner').height()-50){
          $('header').addClass('headerbg')
          $('header').removeClass('goheader')
          $('.img1').addClass('hide')
          $('.img2.hide').removeClass('hide')
          $('.backTop').removeClass('hide')
        }else{
          $('header').removeClass('headerbg')
          $('.img1').removeClass('hide')
          $('.img2').addClass('hide')
          $('.backTop').addClass('hide')
        }
      },
      body(){
        event.stopPropagation();
        this.show=false;
      },
      // 时间下拉的显示，隐藏
      drop(){
        event.stopPropagation();
        this.show=!this.show;
      },
      goNewsdetail(id){
        this.$router.push(`./newsDetail?id=${id}&cateId=${this.$route.query.id}`)
      },
      handleCurrentChange(val) {
        axios.get(`http://zzrunta.com/bxsite/api/newsInformation/getNewsInformationList?page=${val}&number=6&id=8&queryTime=${this.$route.query.queryTime}`).then((res)=>{
          this.newsTotal= res.data.num
          console.log(res.data)
            res.data.news.map((val,index)=>{
              var sep = "-"
              val.addTime = this.date(val.addTime,sep)
            })
          
          this.newsList= res.data.news
          console.log(this.newsList)
          if(this.newsList.length==0){
            $('.tishi').remove('.tishi')
            $('.main').append('<div class="tishi" style="font-size:27px;">暂无动态</div>')
            $('.block').addClass('hide')
          }else{
            $('.tishi').remove('.tishi')
            $('.block').removeClass('hide')
          }
          if(val==1&&this.newsList.length<6){
            $('.block').addClass('hide')
          }else{
            $('.block').removeClass('hide')
          }
          if($('.tishi').length==1 || this.newsList.length<2){
            $('.contauner-fliud footer').css({"position": "fixed","bottom":"0"})
            $('.block').css({"margin-bottom":"7%"})
          }else{
            $('.contauner-fliud footer').removeAttr("style","")
            $('.block').removeAttr("style","")
          }
        }) 
        this.$router.push(`./news?id=8&page=${val}&number=6&queryTime=${this.$route.query.queryTime}`)
      },
      handleSizeChange(val) {},
      addClass:function(item){ 
        this.rightTitle =item.time
        this.current=item.queryTime
        this.customerNum=item.queryTime
        this.$router.push(`./news?id=8&page=1&number=6&queryTime=${item.queryTime}`)
      },
      getStatus (urlStr) {
        this.customerNum = urlStr || 4
        this.current = urlStr || 4
      },
      //监听路由的变化，请求数据
      loadPageData (queryTime,page) {
        this.currentPage1 =Number(page) || 1
        if(queryTime==1){
          this.rightTitle="近一个月"
        }
        if(queryTime==2){
          this.rightTitle="近三个月"
        }
        if(queryTime==3){
          this.rightTitle='近六个月'
        }
        if(queryTime==4){
          this.rightTitle='近一年'
        }
        if(queryTime==5){
         this.rightTitle="更久"
        }
        axios.get(`http://zzrunta.com/bxsite/api/newsInformation/getNewsInformationList?page=${page}&number=6&id=8&queryTime=${queryTime}`).then((res)=>{
          this.newsTotal = res.data.num
          res.data.news.map((val,index)=>{
            var sep = "-"
            val.addTime =this.date(val.addTime,sep)
          })
          this.newsList = res.data.news
          if(this.newsList.length==0){
            $('.tishi').remove('.tishi')
            $('.main').append('<div class="tishi" style="font-size:27px;">暂无动态</div>')
            $('.block').addClass('hide')
          }else{
            $('.tishi').remove('.tishi')
            $('.block').removeClass('hide')
          }
          if(page==1&&this.newsList.length<6){
            $('.block').addClass('hide')
          }else{
            $('.block').removeClass('hide')
          }
          if($('.tishi').length==1 || this.newsList.length<2){
            $('.contauner-fliud footer').css({"position": "fixed","bottom":"0"})
            $(".block").css({"margin-bottom":"7%"})
          }else{
            $('.contauner-fliud footer').removeAttr("style","")
            $('.block').removeAttr("style","")
          }
        })
      },
      //改变时间戳的格式
      //将单个字符转换成双个字符
      doubleNum(n) {
        const str = "" + n;
        return str[1] ? str : `0${str}`;
      },
      // 时间戳转换时间格式
      date (timestamp, sep = "-") {
        var _date = new Date(timestamp);
        var year = _date.getFullYear();
        var month = _date.getMonth() + 1;
        var day = _date.getDate();
        return [year+'.'+ month+'.'+ day].map(this.doubleNum).join(sep);
      },
    },
    mounted() {
      // 监听滚动条的滚动长度
      window.addEventListener('scroll', this.scrollToTop)
      this.currentPage1 =Number(this.$route.query.page) || 1
      this.handleCurrentChange(this.currentPage1)
      if(this.$route.query.queryTime==1){
        this.rightTitle='近一个月'
      }
      if(this.$route.query.queryTime==2){
        this.rightTitle='近三个月'
      }
      if(this.$route.query.queryTime==3){
        this.rightTitle='近六个月'
      }
      if(this.$route.query.queryTime==4){
        this.rightTitle='近一年'
      }
      if(this.$route.query.queryTime==5){
        this.rightTitle='更久'
      }
      this.customerNum = this.$route.query.queryTime || 4
      this.current = this.$route.query.queryTime || 4
      axios.get(`http://zzrunta.com/bxsite/api/newsInformation/getNewsInformationList?page=${this.$route.query.page}&number=6&id=8&queryTime=${this.$route.query.queryTime}`).then((res)=>{
        this.newsTotal=res.data.num
        res.data.news.map((val,index)=>{
          var sep = "-"
          val.addTime =this.date(val.addTime,sep)
        })
        this.newsList = res.data.news
        if(this.newsList.length==0){
          $('.tishi').css({"display":"none"})
          $('.main').append('<div class="tishi" style="font-size:27px;">暂无动态</div>')
        }else{
          $('.tishi').css({"display":"none"})
        }
        if(this.$route.query.page==1&&this.newsList.length<6){
          $('.block').addClass('hide')
        }else{
          $('.block').removeClass('hide')
        }
        if($('.tishi').length==1 || this.newsList.length<2){
          $('.contauner-fliud footer').css({"position": "fixed","bottom":"0"})
          $('.block').css({"margin-bottom":"7%"})
        }else{
          $('.contauner-fliud footer').removeAttr("style","")
          $('.block').removeAttr("style","")
        }
      })
    },
    watch: {
      '$route' (to, from) {
        this.getStatus(this.$route.query.queryTime,this.$route.path)
        this.loadPageData(to.query.queryTime,to.query.page)
      }
    },
  } 
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang = "scss">
  @import '@/lib/reset.scss';
  .Componycontainer{
    .hide{
      display:none;
    }
    /* header*/
    .content .banner{
      position: relative;
      width: 100%;
      height: auto;
      overflow: hidden;
    }
    .content .banner div{
      position: absolute;
      top:35%;
      left:43%;
      text-align: left;
    }
    .content .banner img{
      position: relative; 
      width:100%;
    }
    .content .banner div .p1{
      font-size: 65px;
      line-height:65px;
      color: #fff;
    }
    .content .banner div .p2{
      font-size:27px;
      color: #fff;
    }
    /* title 位置 */
    .content .title{
      margin:1% 20% 1%;
    }
    .content .title .p1 span{
      cursor:pointer;
    }
    .content .title .p1{
      font-size: 20px;
      color: #888;
      line-height: 50px;
    }
    .content .title .p2{
      font-size: 35px;
      color: #333;
      line-height: 50px;
    }
    /* 全部*/
    .Htitle{
      position:relative;
      margin:1% 20%;
    }
    .Htitle .HtitleLeft{
      font-size: 20px;
      color: #333;
      display:flex;
    }
    .Htitle .HtitleLeft:hover{
      cursor: pointer;
    }
    .Htitle .Left1{
      width:6%;
      color: #fff;
      padding:0.5% 0;
      text-align: center;
      background-image: url('../assets/img/quanbudise.png');
      margin-right: 5%;
    }
    /* 点击下拉 时间选择 */
    .Left2 ul{
      color: #333333;
      font-size: 20px;
      padding: 5% 0;
    }
    .Left2 ul li img{
      vertical-align:middle;
      width:15px;
      height:15px;
      margin-bottom: 0.5%
    }
    .Left2 ul .dropTitle :first-child, .Left2>ul>li>:first-child{
      margin-bottom: 5.5%;
    }
    .Left2 ul li span{
      cursor:pointer;
      display:inline-block;
      text-align:center;
    }
    .Left2 .active{
      background-color: #052c6b;
    }
    .Left2 .drop{
      font-size: 18px;
      position: absolute;
      z-index:1;
      width:8%;
      margin-top:1%;
    }
    .Left2 .dropTitle{
      color:#fff;
      font-size: 18px;
      background-image: url("../assets/img/quanbudise.png");
      text-align: center;
      margin-bottom: 1px; 
    }
    .Left2 .dataContent{
      color:#fff;
      background-image: url("../assets/img/shijianxialaitiao.png");
    }
    .Left2 .dropContent{
      padding:3% 10%;
    }
    .Left2 .dropContent:hover{
      background-color:  #2276fd;
    }
    /* 卡片，列表切换 */
    .Htitle .tabTitle{
      display:inline-block;
      font-size: 20px;
      color:#333;
      position: absolute;
      right:2%;
      top:-60%;
    } 
    .Htitle .tabTitle ul{
      display: flex; 
    }
    .Htitle .tabTitle ul li:hover{
      cursor: pointer;
    }
    /* 卡片 */
    .Htitle .tabTitle .oneLi::before{
      content: " ";
      display:inline-block;
      height: 30px;
      width: 30px;
      background: url("../assets/img/kapian.png") no-repeat;
      background-size: 100%;
      vertical-align: bottom;
    }
    .Htitle .tabTitle .oneLi.active,.Htitle .tabTitle .twoLi.active{
      color:#154899;
    }
    .Htitle .tabTitle .oneLi.active::before{
      content: " ";
      display:inline-block;
      height: 30px;
      width: 30px;
      background: url("../assets/img/kapian1.png") no-repeat;
      background-size: 100%;
      vertical-align: bottom;
    }
    /* 列表 */
    .Htitle .tabTitle .twoLi.active::before{
      content: " ";
      display:inline-block;
      height: 30px;
      width: 30px;
      background: url("../assets/img/liebiao1.png") no-repeat;
      background-size: 100%;
      vertical-align: bottom;
    }
    .Htitle .tabTitle .twoLi::before{
      content: "";
      content: " ";
      display:inline-block;
      height: 30px;
      width: 30px;
      background: url("../assets/img/liebiao.png") no-repeat;
      background-size: 100%;
      vertical-align: bottom;
    }
    /* 显示内容 */
    .main{
      margin:1% 20%;
    }
    /* 卡片内容样式 */
    /* 卡片 图片 */
    .main .tabContent .oneContent ul li .TopImg{
      width:100%;
      height:61.5%;
      overflow: hidden;
    }
    .main .tabContent .oneContent ul li .TopImg>img{
      width:100%;
      /* height:100%; */
    }
    .main .tabContent .oneContent ul{
      display: flex;
      flex-warp:warp; /*CSS3样式，支持webkit，ms*/
      -ms-flex-wrap: wrap;/*IE9以及一下不支持*/
      -webkit-flex-wrap: wrap;
    }
    .tabContent .oneContent ul li{
      position: relative;
      float: left;
      box-shadow: #ccc 0px 0px 4px 1px; 
      width:30.5%;
      height: 420px;
      margin:2% 1% 4%;
    }
    .main .tabContent .oneContent ul li:hover{
      cursor: pointer;
    }
    .oneContent .detailContent{
      margin:0 2%;
    }
    /* 卡片 标题 / 列表 标题 */
    .oneContent .ItemTitle,.twoContent .ItemTitle{
      font-size: 22px;
      color:#333;
    }
    /*卡片 内容 */
    .oneContent .Content1{
      padding: 0% 1.5% 0 0;
      width:100%;
      height:60px;
      overflow: hidden;
      font-size:"思源黑体";
      font-size: 16px;
      color:#666;
    }
    .oneContent .detailContent .ItemTitle{
      height:66px;
      margin:1% 0 0%;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -moz-line-clamp: 2;
      -ms-line-clamp: 2;
      -o-line-clamp: 2;
      line-clamp: 2;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      -moz-box-orient: vertical;
      -o-box-orient: vertical;
      -ms-box-orient: vertical;
      /*! autoprefixer: on */
    }
    .oneContent .ncontent1{
      text-indent: 2em;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -moz-line-clamp: 2;
      -ms-line-clamp: 2;
      -o-line-clamp: 2;
      line-clamp: 2;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      -moz-box-orient: vertical;
      -o-box-orient: vertical;
      -ms-box-orient: vertical;
      /*! autoprefixer: on */
    }
    /* 卡片 时间 点击次数 */
    .oneContent .oneData{
      position:absolute;
      bottom:0;
      width:96%;
      margin-top:5%;
      padding-bottom: 1%;
    }
    .oneContent .oneData div,.twoContent .twoData div{
      display:inline-block;
      width: 64%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      color:#333;
    }
    .oneContent .oneData div img{
      margin-top:-5%;
    }
    /* 列表内容样式 */
    .twoContent ul li{
      padding:2% 1% 1%;
      border-bottom: 1px solid #ccc;
    }
    .twoContent .twoData div img{
      margin-top:-5%;
    }
    .twoContent span,.oneContent span{
      font-size:"思源黑体";
      font-size: 14px;
      color:#666;
    }
    /* 列表内容 */
    .twoContent .Content2{
      overflow: hidden;
      font-size:"思源黑体";
      font-size: 16px;
      color:#666;
    }
    .twoContent .ncontent2{
      width:85%;
      line-height: 30px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    /* 分页 */
    .el-pagination {
      text-align: center;
      white-space: nowrap;
      padding: 20px 10px 0;
      color: #303133;
      font-weight: 700;
    }
    @media screen and (max-width:1680px) and (min-width:1440px){
      .Left2 .drop{
        position: absolute;
        z-index:1;
        width:9.5%;
        margin-top:1%;
      }
      .oneContent .ItemTitle,.twoContent .ItemTitle{
        font-size: 20px;
      }
      .main .tabContent .oneContent ul li .TopImg{
        width:100%;
        height:59%;
        overflow: hidden;
      }
      .oneContent .Content1{
        padding: 1.5% 1.5% 0 0;
        width:100%;
        height:65px;
        font-size: 16px;
        color:#666;
      }
      .oneContent .detailContent .ItemTitle{
        height:60px;
        margin:1% 0 1%;
      }
      .tabContent .oneContent ul li{
        height: 370px;
      }
    }
    @media screen and (max-width:1440px) and (min-width:1366px){
      /* header */
      .content .banner div{
        position: absolute;
        top:36%;
        left:41%;
        text-align: left;
      }
      .content .banner div .p1{
        font-size: 55px;
        line-height: 60px;
      }
      .content .banner div .p2{
        font-size:23px;
      }
      /*时间下拉 */
      .Left2 .drop{
        position: absolute;
        z-index:1;
        width:11%;
        margin-top:1%;
      }
      /* 新闻内容 */
      .oneContent .ItemTitle,.twoContent .ItemTitle{
        font-size:19px;
      }
      .main .tabContent .oneContent ul li .TopImg{
        width:100%;
        height:59%;
        overflow: hidden;
      }
      .oneContent .Content1{
        padding: 1.5% 1.5% 0 0;
        width:100%;
        height:65px;
        font-size: 16px;
        color:#666;
      }
      .oneContent .detailContent .ItemTitle{
        height:56px;
        margin:1% 0 0%;
      }
      .twoContent .ncontent2{
        width:90%;
      }
      .tabContent .oneContent ul li{
        height: 355px;
        margin:2% 1% 5%;
      }
    }
    @media screen and (max-width:1366px) and (min-width:1280px){
      /* header */
      .content .banner div{
        position: absolute;
        top:33%;
        left:41%;
        text-align: left;
      }
      .content .banner div .p1{
        font-size:53px;
        line-height: 57px;
      }
      .content .banner div .p2{
        font-size:22px;
      }
      /* 时间下拉 */
      .Left2 .dropTitle{   font-size: 16px;}
      .Left2 .drop{
        font-size: 16px;
        width:11%;
      }
      .Left2 .dropContent{
        padding:3% 9%;
      }
      /* 新闻内容 */
      .oneContent .Content1{
        padding: 1.5% 1.5% 0 0;
        width:100%;
        height:60px;
        overflow: hidden;
        font-size:"思源黑体";
        font-size: 15px;
        color:#666;
      }
      .oneContent .detailContent .ItemTitle{
        height:56px;
        margin:1% 0 0%;
      }
      .oneContent .ItemTitle,.twoContent .ItemTitle{
        font-size:18px;
      }
      .twoContent .ncontent2{
        width:93%;
      }
      .main .tabContent .oneContent ul li .TopImg{
        width: 100%;
        height: 56%;
        overflow: hidden;
      }
      .main .tabContent .oneContent ul li .TopImg img{
        width:100%;
        /* height:100% */
      }
      .tabContent .oneContent ul li{
        height: 330px;
        margin:2% 1% 5%;
      }
    }
    @media screen and (max-width:1280px) and (min-width:1024px){
      /* header */
      .content .banner div{
        position: absolute;
        top:37%;
        left:41%;
        text-align: left;
      }
      .content .banner div .p1{
        font-size:50px;
        line-height:60px;
      }
      /*副标题  */
      .content .banner div .p2{
        font-size:22px;
      }
      .content .title .p1{
        font-size: 18px;
        line-height: 30px;
      }
      .content .title .p2{
        font-size: 30px;
        line-height: 40px;
      }
      .Htitle .HtitleLeft{
        font-size: 17px;
      }
      .Htitle .Left1{
        width:6%;
        padding:0.6% 0;
      }
      /* 时间下拉 */
      .Left2 .dropTitle{   font-size: 16px;}
      .Left2 ul{
        font-size:15px;
      }
      .Left2 .drop{
        width:10.5%;
      }
      /* 列表 卡片 */
      .Htitle .tabTitle{
        font-size: 17px;
      } 
      .Htitle .tabTitle .oneLi::before{
        content: " ";
        display:inline-block;
        height: 22px;
        width:22px;
        background: url("../assets/img/kapian.png") no-repeat 0px -2px;
        background-size: 100%;
      }
      .Htitle .tabTitle .oneLi.active::before{
        content: " ";
        display:inline-block;
        height:22px;
        width: 22px;
        background: url("../assets/img/kapian1.png") no-repeat 0px -2px;
        background-size: 100%;
      }
      .Htitle .tabTitle .twoLi.active::before{
        content: " ";
        display:inline-block;
        height: 22px;
        width: 22px;
        background: url("../assets/img/liebiao1.png") no-repeat 0px -2px;
        background-size: 100%;
      }
      .Htitle .tabTitle .twoLi::before{
        content: " ";
        display:inline-block;
        height: 22px;
        width: 22px;
        background: url("../assets/img/liebiao.png") no-repeat 0px -2px;
        background-size: 100%;
      }
      /* 新闻内容 */
      .oneContent .ItemTitle,.twoContent .ItemTitle{
        font-size:19px;
      }
      .twoContent .ncontent2{
        width:93%;
      }
      .main .tabContent .oneContent ul li .TopImg{
        width: 100%;
        height: 55%;
        overflow: hidden;
      }
      .main .tabContent .oneContent ul li .TopImg img{
        width:100%;
        /* height:100%; */
      }
      .oneContent .Content1{
        padding: 1.5% 1.5% 0 0;
        width:100%;
        height:60px;
        overflow: hidden;
        font-size: 16px;
      }
      .oneContent .detailContent .ItemTitle{
        height:56px;
        margin:1% 0 1%;
      }
      .twoContent .ncontent2{
        width:93%;
      }
      .tabContent .oneContent ul li{
        height:320px;
      }
    }
    @media screen and (max-width:1024px)and (min-width:650px){
      /* header */
      .content .banner div{
        position: absolute;
        top:34%;
        left:39%;
        text-align: left;
      }
      .content .banner div .p1{
        font-size:42px;
        line-height:40px;
      }
      .content .banner div .p2{
        font-size:17px;
        line-height:40px;
      }
      /* 副标题 */
      .content .title .p1{
        font-size: 17px;
        line-height: 30px;
      }
      .content .title .p2{
        font-size: 28px;
        line-height: 40px;
      }
      .Htitle .HtitleLeft{
        font-size: 16px;
      }
      .Htitle .Left1{
        width:6%;
        padding:0.6% 0;
      }
      /* 时间下拉 */
      .Left2 .dropTitle{font-size: 15px;}
      .Left2 ul{
        font-size:15px;
      }
      .Left2 .drop{
        font-size: 15px;
        width:13%;
      }
      .Left2 .dropContent{
        padding:3% 8%;
      }
      /* 列表 卡片 */
      .Htitle .tabTitle{
        font-size: 16px;
      } 
      .Htitle .tabTitle .oneLi::before{
        content: " ";
        display:inline-block;
        height: 20px;
        width:20px;
        background: url("../assets/img/kapian.png") no-repeat 0px -3px;
        background-size: 100%;
      }
      .Htitle .tabTitle .oneLi.active::before{
        content: " ";
        display:inline-block;
        height:20px;
        width: 20px;
        background: url("../assets/img/kapian1.png") no-repeat 0px -3px;
        background-size: 100%;
      }
      .Htitle .tabTitle .twoLi.active::before{
        content: " ";
        display:inline-block;
        height: 20px;
        width: 20px;
        background: url("../assets/img/liebiao1.png") no-repeat 0px -3px;
        background-size: 100%;
      }
      .Htitle .tabTitle .twoLi::before{
        content: " ";
        display:inline-block;
        height: 20px;
        width: 20px;
        background: url("../assets/img/liebiao.png") no-repeat 0px -3px;
        background-size: 100%;
      }
      /* 新闻内容 */
      .oneContent .ItemTitle,.twoContent .ItemTitle{
        font-size:17px;
      }
      .twoContent .ncontent2{
        width:95%;
      }
      .main .tabContent .oneContent ul li .TopImg{
        width:100%;
        height:52%;
        overflow: hidden;
      }
      .oneContent .detailContent .ItemTitle{
        height:53px;
        margin:1% 0 1%;
      }
      .main .tabContent .oneContent ul li .TopImg img{
        width:100%;
        /* height:100%; */
      }
      .tabContent .oneContent ul li{
        height:290px; 
        margin:2% 1% 5%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/News.vue